<template>
  <el-dialog title="增加奖品数量" :visible="isShowAddNum" width="500px" @close="close">
      <div>
        <div class="card-point tipBg">
          <div class="card-rule" style="width: 20px;"></div>
          <div class="card-connet">
            <p>活动进行中时，只能增加奖品数量</p>
          </div>
        </div>
        <el-form label-width="170px" v-if="prizeData">
          <el-form-item label="奖品名称：">
            <span>{{ prizeData.title }}</span>
          </el-form-item>
          <el-form-item label="当前活动奖品总数量：">
            <span>{{ prizeData.num }}</span>件
          </el-form-item>
          <el-form-item label="增加数量：">
            <el-input v-model="addNum" style="width: 150px;"
            @keyup.native="limitInput($event)"></el-input>
          </el-form-item>
          <el-form-item label="追加后奖品总数量数量：">
            <span>{{ afterTotal }}</span>件
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button @click="confirmChange()" type="primary" style="margin-left: 8px">确定</el-button>
      </div>
    </el-dialog>
</template>
<script>
import { checkPrizeStock,pointsExchangeAddStock } from "@/api/integralCenter/integralTask.js";
export default {
  props:{
    isShowAddNum: {
      type: Boolean,
      default: false
    },
    prizeData: {
      type: Object,
      default: {}
    },
    isExchangeAct: {
          type: Boolean,
          default: false
    }
  },
  data() {
    return {
      addNum: '',
    }
  },
  computed:{
    afterTotal() {
      if(this.prizeData){
        return Number(this.prizeData.num) + Number(this.addNum)
      }else {
        return 0;
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
      this.addNum = '';
    },
    confirmChange() {

   if(this.isExchangeAct) {
      // TODO: 增加兑换活动奖品数量逻辑
      pointsExchangeAddStock({
          activityId: this.prizeData.activityId,
          addStock: this.addNum
        }).then((res)=>{
          if(res.code == 1){
            this.$emit('confirm', this.afterTotal);
            this.addNum = '';
            this.$message.success("新增库存成功")
          }else {
            this.$message.error("新增失败！")
          }
        })
      } else {
        checkPrizeStock({
          couponType: this.prizeData.prizeType == 1? this.prizeData.couponType : undefined,
          prizeType: this.prizeData.prizeType,
          assetsId: this.prizeData.assetsId || this.prizeData.id,
          needNum: this.afterTotal
        }).then((res)=>{
          if(res.code == 1){
            this.$emit('confirm', this.afterTotal);
            this.addNum = '';
          }else {
            this.$message.error("新增数量不能大于该奖品的剩余数量！")
          }
        })
      }
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>